import { BEConfig } from "../config/env";
import { getGuestAccessToken } from "../util/storeHelper";
import { webapiPost } from "../webapis/core";
import ApiService from "./apiService";
import { ContextStorage } from "@/libs/contextStorage";

class GuestService extends ApiService {
  getBaseUrl() {
    const { baseURL, protocol, port, versionInfo } = BEConfig.customerApi;

    return `${protocol}${baseURL}${port}${versionInfo}`;
  }

  async guestRegistration(body) {
    try {
      const endpoint = `${this.getBaseUrl()}${
        BEConfig.customerApi.guestUserHandle
      }`;
      const response = await webapiPost(this.getAccessToken(), endpoint, body)
        .request;

      return response;
    } catch (error) {
      return error.response;
    }
  }

  async completeRegistration(body) {
    const endpoint = `${this.getBaseUrl()}${
      BEConfig.customerApi.guestUserHandle
    }/complete`;

    const response = await webapiPost(this.getAccessToken(), endpoint, body)
      .request;
    return response;
  }

  async verifyOTPRegistration(body: { otp: string; token: string }) {
    const endpoint = `${this.getBaseUrl()}${
      BEConfig.customerApi.guestUserHandle
    }/verify-otp`;

    const response = await webapiPost(this.getAccessToken(), endpoint, body)
      .request;
    return response;
  }
}

const instance = new GuestService();

export default instance;
